module.exports = __webpack_public_path__ + "img/avatar-placeholder-female.fc01ebb8.png";